export default __webpack_public_path__ + "static/media/menu_user_icon.6540d734.svg";